// extracted by mini-css-extract-plugin
export var divider = "_fl-7";
export var itemsToggle = "_fl-8";
export var mergeModal = "_fl-1";
export var optionCard = "_fl-4";
export var radioGroup = "_fl-6";
export var radioOption = "_fl-0";
export var selected = "_fl-5";
export var shipmentOptions = "_fl-2";
export var tableOptions = "_fl-3";